import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { EventRecord } from '../entities/records';
import * as selectors from '../entities/Event/selectors';

function mapStateToProps(state, { eventId }) {
  return {
    event: selectors.eventById(state, eventId),
  };
}

export default compose(
  setPropTypes({
    eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    event: PropTypes.instanceOf(EventRecord),
  }),
)(mapStateToProps);
